import { Asset } from '@cube3/common/model/schema/resources/asset';
import { Project } from '@cube3/common/model/schema/resources/project';
import React from 'react';
import { HBox } from '../../templates/layout/Flex';
import { Typography } from '../../atoms/Typography';
import { Folder } from '@cube3/common/model/schema/resources/folder';
import { Thumbnail } from '../../atoms/Thumbnail/Thumbnail';
import { SizeVariants } from '../../../theme/themes';
import { makeCSS } from '../../../utils/makeCSS';
import { SuggestionItemStatus } from './AccountSuggestionItem';
import { Key } from '../../atoms/Key';

interface ResourceSuggestionItemProps {
  item: (Asset | Project | Folder) & SuggestionItemStatus;
  /**  Whether should show a modifier to indicate the shortcut for this option */
  showModifier?: boolean;
}

const useCSS = makeCSS(({ theme }) => ({
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    flexGrow: 1
  },
  thumbnail: {
    width: theme.spacing['16'],
    flexGrow: 0,
    overflow: 'hidden'
  },
  modifier: {}
}));

export const ResourceSuggestionItem = (props: ResourceSuggestionItemProps) => {
  const { item, showModifier } = props;

  const classes = useCSS();
  const isAsset = item.type === 'asset';
  const disabled = item.disabled;
  return (
    <HBox align="center" justify="start" onClick={item.onClick}>
      <div className={classes.thumbnail}>
        <Thumbnail
          resource={item}
          src={isAsset ? item.display_image : undefined}
          fileIcon={item.type === 'project' ? 'project' : 'folder'}
          size={SizeVariants.sm}
          content={isAsset ? 'placeholder' : 'file'}
        />
      </div>

      <div className={classes.textContainer}>
        <Typography colorVariant={disabled ? '03' : '01'} weight="body">
          {item.display_name}
        </Typography>
      </div>
      {showModifier && item.active && !item.disabled ? (
        <div className={classes.modifier}>
          <Key
            keyCode={'Enter'}
            variant="modifier"
            modifierSize={SizeVariants.md}
          />
        </div>
      ) : null}
      {disabled && item.disabledReason ? (
        <Typography colorVariant="03" weight="body" variant={SizeVariants.sm}>
          {item.disabledReason.toUpperCase()}
        </Typography>
      ) : null}
    </HBox>
  );
};
